import { includes } from 'lodash';

// The Language table in MEC stores the ISO codes with underscores (e.g. `fr_CA`).
// However, in the browser, the `lang` attribute is guided by a standard that specifies `-` instead of `_`.
// See: https://jira.medallia.com/browse/EEQ-91977

const normalizeLangAttribute = (surveyLanguage?: string | null) => {
  if (!surveyLanguage || !includes(surveyLanguage, '_')) {
    return;
  }

  document.documentElement.setAttribute('lang', surveyLanguage.replace('_', '-'));
};

export default normalizeLangAttribute;
